// extracted by mini-css-extract-plugin
export const active = "RewardDetailsTabsMobile__active__KkzPq";
export const arrow = "RewardDetailsTabsMobile__arrow__NyrAj";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const option = "RewardDetailsTabsMobile__option__RLAeM font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const popupTitleWrapper = "RewardDetailsTabsMobile__popupTitleWrapper__ecmh+";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const toggle = "RewardDetailsTabsMobile__toggle__nLuD2 font-faces__sansBold__vF+EN font-faces__sans__uCf65";